function initSwiperControl() {
  // Only initialize Swiper for screens <= 1024px (tablets and mobile)
  if (window.innerWidth <= 1024) {
    var swiperControl = new Swiper(".swiper-control", {
      loop: true,
      slidesPerView: "auto",
      slidesPerGroup: 1,
      spaceBetween: 24,

      breakpoints: {
        768: {
          slidesPerView: "auto",
          slidesPerGroup: 1,
          spaceBetween: 24,
        },

        1025: {
          slidesPerView: "auto",
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
      },

      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        renderBullet: function (index, className) {
          // Add a leading 0 for single-digit numbers
          let number = index + 1;
          if (number < 10) {
            number = "0" + number;
          }
          return '<span class="' + className + '">' + number + "</span>";
        },
      },

      navigation: {
        nextEl: ".swiper-next",
        prevEl: ".swiper-prev",
      },
    });
  }
}

// Run the function initially on page load
initSwiperControl();

// Optionally, listen for window resize events to destroy or re-initialize Swiper when resizing
window.addEventListener("resize", function () {
  // Remove existing Swiper instance if any on larger screens
  var swiperInstance = document.querySelector(".swiper-control").swiperControl;
  if (swiperInstance && window.innerWidth > 1024) {
    swiperInstance.destroy(true, true); // destroy swiper on larger screens
  } else if (!swiperInstance && window.innerWidth <= 1024) {
    initSwiperControl(); // re-initialize swiper if resized back to <= 1024px
  }
});
